let isInitDatePicker = false;

window.initDatePicker = function (options) {
    if (!isInitDatePicker) {
        $('.datePicker').datetimepicker({
            locale: 'fr',
            format: 'DD/MM/YYYY',
            icons: {
                time: "far fa-clock-o",
                date: "far fa-calendar",
                up: "far fa-arrow-up",
                down: "far fa-arrow-down",
                next: "far fa-arrow-right",
                previous: "far fa-arrow-left"
            },
            ...options
        });
    }
    isInitDatePicker = true;
}
